import {STATUS_KENTICO} from './feed-kentico';
export class FeedKenticoFilters {
  status: STATUS_KENTICO;
  documentId : string;
  start: Date;
  end: Date;
  day : Date;
}
